














































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Watch } from 'vue-property-decorator';
import { surveyAnalyzeModule } from '@/store/modules/frames/survey-analyze.module';
import GCustomBreadCrumb from '@/components/GCustomBreadCrumb.vue';
import GTitleBar from '@/components/GTitleBar.vue';
import GTemplateTopicForm from '@/components/GTopicForm.vue';
import GSurveyAnalyzeFilter from '@/views/GSurveyAnalyze/GSurveyAnalyzeFilter.vue';
import GSurveyChart from '@/views/GSurveyAnalyze/GSurveyChart.vue';
import GStatisticsChart from '@/views/GStatistics/GStatisticsChart.vue';
import GLoading from '@/components/GLoading.vue';
import GStatisticsBoxplotSubTableInfoTable from '@/components/GStatisticsBoxplotSubTableInfoTable.vue';
import { SurveyAnalysisTabelMapping } from '@/models/jgrow/survey-analysis-tabel-mapping';
import GOptionalData from '@/components/GOptionalData.vue';

@Component({
  name: 'GSurveyAggressiveEntry',
  components: {
    GLoading,
    GSurveyChart,
    GSurveyAnalyzeFilter,
    GTemplateTopicForm,
    GTitleBar,
    GCustomBreadCrumb,
    GStatisticsChart,
    GOptionalData,
    GStatisticsBoxplotSubTableInfoTable,
  },
  computed: {},
  methods: {},
})
export default class GSurveyAggressiveEntry extends mixins(GPageBase) {
  columns: any[] = [];
  surveyAnalysisTabels: SurveyAnalysisTabelMapping[] = [];

  // 7段階評価の各ステージに対応するインデックス
  readonly stageIndex = {
    VERY_NEGATIVE:    0, // 非常に消極的
    NEGATIVE:         1, // 消極的
    SOMEWHAT_NEGATIVE:2, // どちらかと言えば消極的
    NEUTRAL:          3, // どちらとも言えない
    SOMEWHAT_ACTIVE:  4, // どちらかと言えば積極的
    ACTIVE:           5, // 積極的
    VERY_ACTIVE:      6, // 非常に積極的
  };

  async mounted() {
    const cellWidth: number = 90;
    this.columns = [
      {
        title: 'アクティビティ名',
        key: 'activity',
        align: 'left',
        slot: 'activity',
      },
      {
        renderHeader: (h: any, _: any) => {
          return h('div', [
            h('span', '非常に'),
            h('br'),
            h('span', '消極的')
          ]);
        },
        key: 'veryNagative',
        width: cellWidth,
        align: 'center',
        slot: 'very-nagative',
      },
      {
        title: '消極的',
        key: 'nagative',
        align: 'center',
        width: cellWidth,
        slot: 'nagative',
      },
      {
        renderHeader: (h: any, _: any) => {
          return h('div', [
            h('span', 'どちらかと'),
            h('br'),
            h('span', '言えば'),
            h('br'),
            h('span', '消極的')
          ]);
        },
        key: 'normal-nagative',
        align: 'center',
        width: cellWidth,
        slot: 'normal-nagative',
      },
      {
        renderHeader: (h: any, _: any) => {
          return h('div', [
            h('span', 'どちらとも'),
            h('br'),
            h('span', '言えない')
          ]);
        },
        key: 'normal',
        align: 'center',
        width: cellWidth,
        slot: 'normal',
      },
      {
        renderHeader: (h: any, _: any) => {
          return h('div', [
            h('span', 'どちらかと'),
            h('br'),
            h('span', '言えば'),
            h('br'),
            h('span', '積極的')
          ]);
        },
        key: 'normal-active',
        align: 'center',
        width: cellWidth,
        slot: 'normal-active',
      },
      {
        title: '積極的',
        key: 'active',
        align: 'center',
        width: cellWidth,
        slot: 'active',
      },
      {
        renderHeader: (h: any, _: any) => {
          return h('div', [
            h('span', '非常に'),
            h('br'),
            h('span', '積極的')
          ]);
        },
        key: 'veryActive',
        align: 'center',
        width: cellWidth,
        slot: 'very-active',
      },
      {
        renderHeader: (h: any, _: any) => {
          return h('div', [
            h('span', '積極的'),
            h('br'),
            h('span', '参加割合')
          ]);
        },
        key: 'aggressiveEntryRate',
        align: 'center',
        width: 90,
        slot: 'aggressive-entry-rate',
      },
      {
        renderHeader: (h: any, _: any) => {
          return h('div', [
            h('span', '強い'),
            h('br'),
            h('span', '積極層割合')
          ]);
        },
        key: 'moreAggressiveEntryRate',
        align: 'center',
        width: 90,
        slot: 'more-aggressive-entry-rate',
      },
    ];

    const rateTables: Map<number, SurveyAnalysisTabelMapping> = await surveyAnalyzeModule.getAggressiveEntryRateTabels();
    this.surveyAnalysisTabels = [...rateTables.values()];
    this.surveyAnalysisTabels.sort((a, b: SurveyAnalysisTabelMapping) => a.id - b.id);
  }

  getActivityName(id: number): string {
    return surveyAnalyzeModule.activityNameMap.get(id);
  }

  formatPercent(p: number): string | number {
    return p === 0 ? 0 : p.toFixed(1);
  }

  calcAggressiveEntryPercent(row: SurveyAnalysisTabelMapping): number {
    return row.pointList[this.stageIndex.SOMEWHAT_ACTIVE].percent
      + row.pointList[this.stageIndex.ACTIVE].percent
      + row.pointList[this.stageIndex.VERY_ACTIVE].percent;
  }

  calcStrongAggressivePercent(row: SurveyAnalysisTabelMapping): number {
    return row.pointList[this.stageIndex.ACTIVE].percent
      + row.pointList[this.stageIndex.VERY_ACTIVE].percent;
  }
}
